<template>
  <v-dialog
    scrollable
    :value="value"
    :fullscreen="isMobile()"
    width="550px"
    @click:outside.stop="$emit('close')"
    @keydown.esc="$emit('close')"
  >
    <v-card flat tile>
      <v-card-title>
        {{ $t('titles.employeeInfo') }}
        <v-spacer/>
        <v-btn icon @click="$emit('close')">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider/>
      <v-card-text class="pa-0">
        <v-card class="pa-2" flat>
          <v-container fluid class="pa-0">
            <v-layout>
              <v-row class="pa-0 ma-0">
                <v-col class="pa-0">
                  <v-card>
                    <v-list class="pa-0">
                      <v-list-item>
                        <v-list-item-icon>
                          <v-icon>person</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-row class="ma-0">
                            <span class="font-weight-bold text-truncate"> {{ $t('tableHeaders.name') }} </span>
                            <v-spacer/>
                            <div>{{ assignmentInfo.employeeName }}</div>
                          </v-row>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-icon>
                          <v-icon>badge</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-row class="ma-0">
                            <span class="font-weight-bold text-truncate"> {{ $t('tableHeaders.employeeId') }} </span>
                            <v-spacer/>
                            <div>{{ assignmentInfo.employeeId }}</div>
                          </v-row>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-icon>
                          <v-icon>work</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-row class="ma-0">
                            <span class="font-weight-bold text-truncate"> {{ $t('tableHeaders.position') }} </span>
                            <v-spacer/>
                            <div>{{ assignmentInfo.description }}</div>
                          </v-row>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-icon>
                          <v-icon>event</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-row class="ma-0">
                            <span class="font-weight-bold text-truncate"> {{ $t('workSchedules.current') }} </span>
                            <v-spacer/>
                            <div>{{ currentWorkScheduleName }}</div>
                          </v-row>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-icon>
                          <v-icon>schedule</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-row class="ma-0">
                            <span class="font-weight-bold text-truncate">
                              {{ $t('workSchedules.timeRecVariant') }}
                            </span>
                            <v-spacer/>
                            <div>{{ readableTimeRecordingVariant }}</div>
                          </v-row>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-col>
              </v-row>
            </v-layout>
          </v-container>
        </v-card>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex';

import isNil from 'lodash/isNil';

import constants from '@/constants';

import displayAdaptable from '@/mixins/displayAdaptable';

export default {
  name: 'ApprovalsWorkScheduleEmployeeInfoDialog',

  props: {
    value: Boolean,
    assignmentInfo: Object,
  },

  mixins: [displayAdaptable],

  computed: {
    ...mapGetters(['getWorkScheduleByExternalCode']),

    readableTimeRecordingVariant() {
      switch (this.assignmentInfo.timeRecordingVariant) {
        case (constants.WorkSchedule.TimeRecordingVariant.CLOCK_TIME):
          return this.$t('workSchedules.timeRecordingVariant.clockTimes');
        case (constants.WorkSchedule.TimeRecordingVariant.DURATION):
          return this.$t('workSchedules.timeRecordingVariant.duration');
        default:
          return this.$t('workSchedules.timeRecordingVariant.unknown');
      }
    },

    currentWorkScheduleName() {
      if (isNil(this.assignmentInfo.currentWorkScheduleCode)) {
        return constants.NONE;
      }
      return this.getWorkScheduleByExternalCode(this.assignmentInfo.currentWorkScheduleCode).externalName;
    },
  },
};
</script>

<style scoped>

</style>
